import { render, staticRenderFns } from "./FormSupplyObject.vue?vue&type=template&id=05c4237d"
import script from "./FormSupplyObject.vue?vue&type=script&lang=js"
export * from "./FormSupplyObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports